export const APP_HOME = { label: 'Home', url: '/' };
export const FEATURE_HOME = {
  label: 'User Management',
  url: '/user-management',
};
export const UserManagementLanding = [APP_HOME, FEATURE_HOME];

// Page: Users
export const USER_LIST_ROUTE = '/user-management/users';
export const userListBreadcrumb = [
  ...UserManagementLanding,
  { label: 'Users', url: USER_LIST_ROUTE },
];

// Page: Roles
export const ROLE_LIST_ROUTE = '/user-management/roles';
export const roleListBreadcrumb = [
  ...UserManagementLanding,
  { label: 'Roles', url: ROLE_LIST_ROUTE },
];

// Page: Groups
export const GROUP_LIST_ROUTE = '/user-management/groups';
export const groupListBreadcrumb = [
  ...UserManagementLanding,
  { label: 'Groups', url: GROUP_LIST_ROUTE },
];
